<div class="inspector-dialog-container" [@changeDialogSize]="inspectorDialogSizeState">
  <div class="dialog-header">
    @if (matStepper.selectedIndex === 0) {
    <div class="inspector-first-title-container">
      <img [src]="inspectorImage" />
      <sg-text class="inspector-first-title" color="black" variant="sg-h3">Inspector</sg-text>
    </div>
    } @else {
    <div class="inspector-header-breadcrumbs">
      <sg-button (onClick)="resetSearch()" class="back-header-button" variant="ghost-secondary" icon="arrow_back"></sg-button>
      <sg-text color="black" variant="sg-sub1">Inspector</sg-text>
      @if (parsedBreadcrumbs) {
      <sg-text
        class="sg-text-ellipsis sg-text-ellipsis-flex-parent header-title-breadcrumbs"
        [ngStyle]="{'maxWidth': inspectorDialogSizeState === 'table' ? '500px' : '410px'}"
        color="decorative-text-02"
        variant="sg-sub1"
        [sgTextOverflowTooltip]="parsedBreadcrumbs">
        {{parsedBreadcrumbs}}
      </sg-text>
      }
    </div>
    }
    <button class="close-dialog-button" mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
  </div>
  <div class="dialog-content">
    <mat-stepper #inspectorStepper>
      <mat-step #selectPartner>
        <sg-inspector-select-partner [inspectorFormModel]="inspectorFormModel" (onClick)="startInvestigation($event)"></sg-inspector-select-partner>
      </mat-step>
      <mat-step #shortcutSearch>
        <sg-inspector-shortcut-search
          [inspectorFormModel]="inspectorFormModel"
          [failedToFind]="noResults$ | async"
          (onClickFindFile)="getOutboundFilesByFileName()"
          (onClickSkip)="goToStep('expandedSearch')"></sg-inspector-shortcut-search>
      </mat-step>
      <mat-step #expendedSearch>
        <sg-inspector-expanded-search [inspectorFormModel]="inspectorFormModel" (onClick)="getOutboundFilesByExpandedSearch()"></sg-inspector-expanded-search>
      </mat-step>
      <mat-step #outboundFromShortcutSearch>
        <sg-inspector-outbound-from-shortcut
          [outboundTableData$]="outboundSwiftFiles$"
          [outboundFileContent$]="outboundSwiftFileContent$"
          [fileNameSearchCriteria]="fileNameSearchCriteria"
          (onClickNavigationButton)="navigateFromOutbound($event)"
          (onClickRow)="getOutboundFileContentById($event)"
          (onClickDownloadFile)="downloadSelectedFile()"
          (onClickClose)="closeDialog()"></sg-inspector-outbound-from-shortcut>
      </mat-step>
      <mat-step #outboundFromExpandedSearch>
        <sg-inspector-outbound-from-expanded
          [outboundTableData$]="outboundSwiftFiles$"
          [outboundFileContent$]="outboundSwiftFileContent$"
          [expandedSearchCriteria]="expandedSearchCriteria"
          (onClickNavigationButton)="navigateFromOutbound($event)"
          (onClickRow)="getOutboundFileContentById($event)"
          (onClickDownloadFile)="downloadSelectedFile()"
          (onClickClose)="closeDialog()"></sg-inspector-outbound-from-expanded>
      </mat-step>
      <mat-step #inbound>
        <sg-inspector-inbound
          [inboundTableData$]="inboundSwiftFiles$"
          [inboundFileContent$]="inboundSwiftFileContent$"
          (onClickRestart)="goToStep('selectPartner')"
          (onClickRow)="getInboundFileContentById($event)"
          (onClickDownloadFile)="downloadSelectedFile()"
          (onClickClose)="closeDialog()"></sg-inspector-inbound>
      </mat-step>
    </mat-stepper>
  </div>
</div>
